
// HTML patterns content can't be placed in const, it's just doesn't work if shitty html RegEx is included in curly brackets
export const FOREIGN_CHARACTERS = new RegExp(/[^a-zA-Z0-9.(@#$%^&+=!*"'/№;~:?_,<>|{}\[)-]/, 'gi');